var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6138 5.64872C21.0337 6.01614 21.0718 6.65623 20.6983 7.07076L10.1844 18.7406C9.80896 19.1573 9.16434 19.1838 8.75597 18.7994L2.67194 13.0718C2.29252 12.7146 2.2562 12.1194 2.58173 11.7125C2.94093 11.2635 3.60984 11.2017 4.03733 11.5862L8.75772 15.8321C9.16794 16.2011 9.79951 16.1681 10.1691 15.7584L19.2126 5.73144C19.5785 5.32568 20.2026 5.2889 20.6138 5.64872Z",
    fill: "#DB4D29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLanguage);
export default __webpack_public_path__ + "static/media/check_language.72115f7498739f8f75d184aca70ea2fa.svg";
export { ForwardRef as ReactComponent };